/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetParkingSpotsRequest } from '../../models/get-parking-spots-request';
import { GetParkingSpotsResponse } from '../../models/get-parking-spots-response';

export interface ApiParkingSpotCmsGetParkingSpotsPost$Json$Params {
      body?: GetParkingSpotsRequest
}

export function apiParkingSpotCmsGetParkingSpotsPost$Json(http: HttpClient, rootUrl: string, params?: ApiParkingSpotCmsGetParkingSpotsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetParkingSpotsResponse>> {
  const rb = new RequestBuilder(rootUrl, apiParkingSpotCmsGetParkingSpotsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetParkingSpotsResponse>;
    })
  );
}

apiParkingSpotCmsGetParkingSpotsPost$Json.PATH = '/api/ParkingSpot/CmsGetParkingSpots';
